var slice = [].slice

let consts = {
  UPLOADING: 'uploading',
  CANCELED: 'canceled',
  ERROR: 'error',
  SUCCESS: 'success'
}

import Queue, {QueueConsumer} from 'blocking-queue'

var filesQueue = new Queue()
var filesQueueConsumer = new QueueConsumer(filesQueue)

filesQueueConsumer.start((data) => {
  console.log(data.options)
  return effectiveUpload(data.files, data.options, data.method, data.url)
}, 1)

let extend = function () {
  var j, key, len, object, val
  let target = arguments[0]
  let objects = arguments.length >= 2 ? slice.call(arguments, 1) : []
  for (j = 0, len = objects.length; j < len; j++) {
    object = objects[j]
    for (key in object) {
      val = object[key]
      target[key] = val
    }
  }
  return target
}

let resolveOption = function () {
  let option = arguments[0]
  let args = arguments.length >= 2 ? slice.call(arguments, 1) : []
  if (typeof option === 'function') {
    return option.apply(this, args)
  }
  return option
}
let createFileInfo = function (file) {
  return {file: file, status: consts.UPLOADING, upload: {progress: 0}}
}

let upload = function (files, options) {
  if (files.length === 0) {
    return
  }
  if (files.length > 1) {
    files.forEach((file) => {
      file.abort = () => {}
      upload([file], options)
    })
    return
  }
  options = extend({}, {
    url: null,
    method: 'post',
    withCredentials: false,
    timeout: 30000,
    parallelUploads: 2,
    uploadMultiple: false,
    maxFilesize: 256,
    paramName: 'file',
    params: {},
    onFinish: (file) => {}
  }, options)
  let method = resolveOption(options.method, files)
  let url = resolveOption(options.url, files)
  if (typeof url === 'string') {
    var urlString = url
    url = new Promise((resolve, reject) => resolve(urlString))
  }
  let _getParamName = function (n) {
    if (typeof options.paramName === 'function') {
      return options.paramName(n)
    } else {
      return '' + options.paramName + (options.uploadMultiple ? '[' + n + ']' : '')
    }
  }
  for (let i = 0; i < files.length; i++) {
    let file = files[i].file
    let paramName = _getParamName(i)
    let fileName = files[i].file.name
    let formData = new FormData()
    if (options.params) {
      let ref1 = resolveOption(options.params, file)
      for (let key in ref1) {
        let value = ref1[key]
        formData.append(key, value)
      }
    }
    formData.append(paramName, file, fileName)
    files[i].formData = formData
  }

  filesQueue.push({files, options, method, url})
}

let effectiveUpload = function (files, options, method, url) {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest()
    for (let j = 0, len = files.length; j < len; j++) {
      let file = files[j]
      file.xhr = xhr
      file.abort = () => {
        file.xhr && xhr.abort()
        resolve()
      }
    }
    url.then((url) => {
      xhr.open(method, url, true)
      xhr.timeout = resolveOption(options.timeout, files)
      xhr.withCredentials = !!options.withCredentials
      let handleError = function () {
        for (let k = 0, len1 = files.length; k < len1; k++) {
          let file = files[k]
          file.status = consts.ERROR
        }
      }
      let updateProgress = function (e) {
        let progress
        if (e != null) {
          progress = 100 * e.loaded / e.total
          for (let k = 0, len1 = files.length; k < len1; k++) {
            let file = files[k]
            file.upload = {
              progress: progress,
              total: e.total,
              bytesSent: e.loaded
            }
          }
        } else {
          // for (let k = 0, len1 = files.length; k < len1; k++) {
          //   let file = files[k]
          //   if (file.upload.progress === 100) {
          //     options.onFinish(file)
          //   }
          // }
        }
      }
      xhr.onload = function (e) {
        if (files[0].status === consts.CANCELED) {
          resolve()
          return
        }
        if (xhr.readyState !== 4) {
          return
        }
        let response = xhr.responseText
        if (xhr.getResponseHeader('content-type') && ~xhr.getResponseHeader('content-type').indexOf('application/json')) {
          try {
            response = JSON.parse(response)
          } catch (error1) {
            response = error1
          }
          for (let k = 0, len1 = files.length; k < len1; k++) {
            let file = files[k]
            file.status = consts.ERROR
            file.response = response
          }
          resolve()
          return
        }
        updateProgress()
        let ref
        if (!(((ref = xhr.status) >= 200 && ref < 300))) {
          resolve()
          return handleError()
        } else {
          for (let k = 0, len1 = files.length; k < len1; k++) {
            files[k].status = consts.SUCCESS
            options.onFinish(files[k])
          }
          resolve()
        }
      }
      xhr.onerror = function () {
        console.log('error')
        if (files[0].status === consts.SUCCESS) {
          return
        }
        resolve()
        return handleError()
      }
      let submitRequest = function (xhr, formData, files) {
        return xhr.send(formData)
      }
      let ref
      let progressObj = (ref = xhr.upload) != null ? ref : xhr
      progressObj.onprogress = updateProgress
      let headers = {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
      if (options.headers) {
        extend(headers, options.headers)
      }
      for (let headerName in headers) {
        let headerValue = headers[headerName]
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue)
        }
      }
      // for (k = 0, len1 = files.length; k < len1; k++) {
      //   let file = files[k]
      //   this.emit('sending', file, xhr, formData)
      // }
      // if (options.uploadMultiple) {
      //   this.emit('sendingmultiple', files, xhr, formData)
      // }
      // if (this.element.tagName === 'FORM') {
      //   ref2 = this.element.querySelectorAll('input, textarea, select, button')
      //   for (l = 0, len2 = ref2.length; l < len2; l++) {
      //     input = ref2[l]
      //     inputName = input.getAttribute('name')
      //     inputType = input.getAttribute('type')
      //     if (input.tagName === 'SELECT' && input.hasAttribute('multiple')) {
      //       ref3 = input.options
      //       for (m = 0, len3 = ref3.length; m < len3; m++) {
      //         option = ref3[m]
      //         if (option.selected) {
      //           formData.append(inputName, option.value)
      //         }
      //       }
      //     } else if (!inputType || ((ref4 = inputType.toLowerCase()) !== 'checkbox' && ref4 !== 'radio') || input.checked) {
      //       formData.append(inputName, input.value)
      //     }
      //   }
      // }
      return submitRequest(xhr, files[files.length - 1].formData, files)
    }).catch(resolve)
  })
}

export {
  upload,
  createFileInfo,
  consts
}



// WEBPACK FOOTER //
// ./src/utils/upload.js